import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import useDebounce from "hooks/useDebounce";
import ReactSelect from "react-select";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { Input, Button } from "styled";
import { TD, TH } from "styled/table";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

const PAGE_SIZE = 100;

const Log = () => {
  const [search, setSearch] = useState("");
  const [model, setModel] = useState("");
  const [page, setPage] = useState(1);

  const debouncedValue = useDebounce(search, 1000);
  const { data: logs, isLoading, isFetching } = useQuery(
    ["logs", model, debouncedValue, page],
    () =>
      getAllData("/log", {
        searchQuery: debouncedValue,
        model: model,
        limit: PAGE_SIZE,
        page: page,
      }),
    {
      keepPreviousData: true,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    }
  );

  const logsData = logs?.data ?? [];
  const totalData = logs?.paginate?.totalData ?? 0;
  const totalPage = logs?.paginate?.totalPage ?? 1;
  const allModels = [
    {
        value: "tyre",
        label: "Tyre"
    },
    {
        value: "vehicle",
        label: "Vehicle"
    },
   
  ]

  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <label className="py-3">
            Model
            <ReactSelect
              options={allModels}
              value={{
                value: model,
                label: allModels?.find((d) => d?.value === model)?.label,
              }}
              onChange={(value) => {
                console.log(value)
                setModel(value.value);
                setPage(1); // Reset to first page when model changes
              }}
              name="model"
              isMulti={false}
            />
            </label>
          </div>
          <div className="relative w-full">
          <label className="py-3">
            Search Here
          <Input
              type="search"
              placeholder="Search Here"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1); // Reset to first page when search changes
              }}
            />
            </label>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Model</TH>
                      <TH scope="col">Number</TH>
                      <TH scope="col">Updated By</TH>
                      <TH scope="col">Updated Time</TH>
                      <TH scope="col">Fleet</TH>
                      <TH scope="col">Hub</TH>
                      <TH scope="col">From</TH>
                      <TH scope="col">To</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {logsData.length === 0 && (
                      <tr>
                        <td colSpan={9} className="text-center p-6 text-sm text-gray-500">
                          No logs found
                        </td>
                      </tr>
                    )}

                    {logsData.map((item, index) => (
                      <ViewList 
                        data={item} 
                        key={item?._id} 
                        index={(page - 1) * PAGE_SIZE + index} 
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {totalPage > 0 && (
            <div className="container mx-auto flex justify-center items-center gap-2 py-5">
              <Button
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
                disabled={page === 1}
                className="disabled:pointer-events-none disabled:opacity-70 px-0"
                primary
              >
                <div className="flex gap-1 items-center">
                  <IoMdArrowBack />
                  Prev Page
                </div>
              </Button>

              <span className="text-gray-600 px-4">
                {`showing: ${
                  totalData === 0 ? 0 : (page - 1) * PAGE_SIZE + 1
                } - ${Math.min(totalData, page * PAGE_SIZE)} of ${totalData}`}
                {isFetching && (
                  <span className="ml-2 text-xs text-gray-400">(updating…)</span>
                )}
              </span>

              <Button
                onClick={() => setPage((p) => Math.min(p + 1, totalPage))}
                disabled={page >= totalPage}
                className="disabled:pointer-events-none disabled:opacity-70 px-0"
                primary
              >
                <div className="flex gap-1 items-center">
                  Next Page
                  <IoMdArrowForward />
                </div>
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Log;

const ViewList = ({ data, index }) => {
  const getDetail = (model, data) => {

    if (!data || typeof data !== 'object') {
      return <span className="text-gray-400">---</span>;
    }

    switch(model?.toLowerCase()){

      case "tyre":
        const val= {
          G1: data.G1,
          G2: data.G2,
          G3: data.G3,
          G4: data.G4,
          Status: data.status,
          "Stencil No": data.stencilNo,
        }
        return Object.keys(val).map(key=>{
          return <tr>
            <TD>{key}: {val[key]}</TD>
          </tr>
        });

       case "vehicle":
        const ab= {
          fleet: data.fleet,
          hub: data.hub,
          mechanicalCondition: data.mechanicalCondition,
          registrationNumber: data.registrationNumber,
          make: data.vehicleMake,
          model: data.model,
          configuration: data.configuration,
          engineNumber: data.engineNumber,
          chasis: data.chasisNumber,
          bodyType: data.bodyType,
          applicationType: data.applicationType,
          registrationYear: data.registrationNumber,
          vehicleCC: data.vehicleCC,
          GVW: data.GW,
        }
         return Object.keys(ab).map(key=>{
          return <tr>
            <TD>{key}: {ab[key]}</TD>
          </tr>
        })
      default: 
      return {}
      
    }
  };

  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
      <TD>{index + 1}</TD>
      <TD className="stock-transfers-stencil-numbers">
        {data.model?.toUpperCase()}
      </TD>
      <TD className="stock-transfers-stencil-numbers">{data.identifier}</TD>
      <TD>
        {data.by ? data.by : "---"}
      </TD>
      <TD>{new Date(data.updatedAt).toLocaleDateString("en-GB").replace(/\//g, '-')}</TD>
      <TD className="stock-transfers-stencil-numbers">{data.fleet}</TD>
      <TD className="stock-transfers-stencil-numbers">{data.hub}</TD>
      <TD>{getDetail(data.model, data.from)}</TD>
      <TD>{getDetail(data.model, data.to)}</TD>
    </tr>
  );
};
